import { GQLError } from '../../apis/graphql/graphqlAPI';
import admanToast from '../../components/Alert/util/admanToast';

export type Error = {
  message: string;
};

export type HandleErrorOptions = {
  setErrorMessages?: (errorMessages: string[]) => void;
  suppressToast?: boolean;
};

export const getErrorMessages = (error: Error): string[] | undefined => {
  try {
    const errors = JSON.parse(error?.message) as GQLError;

    if (error) {
      if (Array.isArray(errors?.details)) {
        const errorsMap = errors.details.map(({ issue }) => issue).filter((error) => !!error);

        if (errorsMap?.length > 0) return errorsMap;
      }

      if (errors.message) return [errors.message];

      return errors.details.map(({ issue }) => issue);
    }
  } catch (e) {
    if (typeof error.message === 'string') {
      return [error.message];
    }
    console.error('Cannot parse Error: ', error);
  }
};

export const getErrorsAsString = (error: Error): string => {
  const errorMessages = getErrorMessages(error);

  return errorMessages ? errorMessages.join('. ') : error.message || '';
};

export function handleError(error: Error): void;
export function handleError(error: Error, options?: HandleErrorOptions): void;

export function handleError(error: Error, options?: HandleErrorOptions): void {
  const errorMessages = getErrorMessages(error) || [];

  if (options?.setErrorMessages) {
    options.setErrorMessages(errorMessages);
  }

  if (!options?.suppressToast) {
    errorMessages.forEach((errorMessage) => {
      admanToast.error(errorMessage);
    });
  }
}

export default handleError;
